module.exports = __webpack_public_path__ + "static/media/vehicle_icon.fc7025d7.svg";